import makeStyles from '@mui/styles/makeStyles'

const useScheduledActivityStyles = makeStyles((theme) => ({
  imageGalleryBox: {
    minHeight: "10em",
    maxHeight: "20em",
    overflow: "auto",
    borderRadius: "6px",
    // boxShadow: "inset 0px 0px 5px 1px rgba(1,1,1,0.1)",
  },
  imageGalleryGrid: {
    margin: 0,
  },
  imageGalleryItem: {
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.4)',
    },
  },
  selectedImage: {
    padding: "0.25em",
    borderRadius: 8,
    width: "6em",
  },
  inviteLink: {
    textAlign: "center",
    fontSize: ".625rem",
    overflowWrap: "anywhere",
    color: theme.palette.neutral.main
  },
  bannerImage: {
    [theme.breakpoints.down('sm')]: {
    },
  },
  emptyCommunityCalendarBox: {
    backgroundColor: theme.palette.neutral.light,
    padding: theme.spacing(2, 3, 2, 3),
    minHeight: '7em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  listTimesBox: {
    backgroundColor: theme.palette.neutral.light,
    color: theme.palette.primary.dark,
    display: 'flex',
    flexDirection: 'row',
    alignItems:'center',
    borderRadius: '2px',
    '&.waitlist': {
      color: theme.palette.neutral.main
    },
    '&.registered': {
      backgroundColor: theme.palette.primary.light,
    }
  }
}))

export default useScheduledActivityStyles
